import React from 'react'
import PropTypes from 'prop-types'

import { getHexCode } from '../../lfcHelpers/colorConvert'

// Use InfoButton instead for MOK
// import Tooltip from "../Tooltip/Tooltip";
import InfoButton from '../../../../InfoButton/InfoButton'

// Not used for MOK
// import ColorPicker from "../ColorPicker/ColorPicker";

import { SelectionLabel } from '../DimensionSelect.styles'

import {
  SelectionButtonWrapper,
  Option,
  BorderBox,
  ColorButton,
  ImageButton,
  SelectionButtonLabel,
} from './Thumbnail.styles'
import { useSelector } from 'react-redux'

const Thumbnail = ({
  id,
  name,
  dimensionCode,
  description,
  selectedValue,
  values,
  variant,
  handleClick,
  language,
  renderCorrectionInformation,
}) => {
  // For MOK, colorSlice is moved to lfcSlice in MOK store
  const { color } = useSelector((state) => state.lfc.color)
  // const { dimensionsWithSelectableValues } = useSelector(
  //   (state) => state.dimensions
  // );

  // value.selectable in the props cannot be trusted so therefor we get if from the redux state instead
  // const currentDimension = dimensionsWithSelectableValues.filter(
  //   (dimension) => {
  //     return `d${dimension.dimensionId}` === id;
  //   }
  // );

  return (
    <div>
      <SelectionLabel htmlFor={id}>{name}</SelectionLabel>

      {/* Use InfoButton instead for MOK */}
      {/* {description && <Tooltip content={description} />} */}
      {description && <InfoButton dangerouslySetInfo={description} />}

      <SelectionButtonWrapper id={id} value={selectedValue}>
        {/* {currentDimension[0].values.map((value) => ( */}
        {/* Use props /MOK */}
        {values.map((value) => (
          <Option
            key={'dv'.concat(value.valueId.toString())}
            border={value.valueId.toString() === selectedValue.toString()}
          >
            <BorderBox border={value.valueId.toString() === selectedValue.toString()}>
              {variant === 'COLOR' ? (
                <ColorButton
                  backgroundColor={
                    value.factoryValueCode === 'NO' || value.factoryValueCode === 'SAME_AS_OUTSIDE'
                      ? getHexCode(color)
                      : getHexCode(value.factoryValueCode)
                  }
                  value={value.valueId}
                  disabled={!value.selectable}
                  onClick={(event) => {
                    handleClick(
                      event,
                      // currentDimension[0].dimensionCode === "dorColor" ||
                      //   currentDimension[0].dimensionCode === "wdwColor"
                      /* Use props /MOK */
                      dimensionCode === 'dorColor' || dimensionCode === 'wdwColor' ? value.factoryValueCode : null
                    )
                  }}
                />
              ) : (
                <ImageButton
                  image={`//s.skbv.se/assets/images/lfc/thumbnail_${dimensionCode}_${value.factoryValueCode}.jpg`}
                  value={value.valueId}
                  disabled={!value.selectable}
                  onClick={(event) => {
                    handleClick(event)
                  }}
                />
              )}
            </BorderBox>
            <SelectionButtonLabel disabled={!value.selectable}>{value[`valueName${language}`]}</SelectionButtonLabel>
          </Option>
        ))}
      </SelectionButtonWrapper>

      {/* Not used for MOK */}
      {/* {(dimensionCode === 'dorColor' || dimensionCode === 'wdwColor') && <ColorPicker />} */}

      {renderCorrectionInformation && renderCorrectionInformation()}
    </div>
  )
}

Thumbnail.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  dimensionCode: PropTypes.string,
  description: PropTypes.string,
  selectedValue: PropTypes.string,
  values: PropTypes.arrayOf(PropTypes.object),
  variant: PropTypes.string,
  handleClick: PropTypes.func,
  language: PropTypes.string,
  renderCorrectionInformation: PropTypes.func,
}

export default Thumbnail
